import { Component, Host, h, Element, Event, EventEmitter } from '@stencil/core';


@Component({
  tag: 'lilu-pagination',
  styleUrl: 'lilu-pagination.scss',
})
export class LiluPagination {

  @Element() el: HTMLElement;
  @Event() pageChanged: EventEmitter<number>;

  componentDidLoad() {
    this.el.querySelector('select')?.addEventListener('change', event => {
      this.pushToBrowserhistory();
      const page = (event.target as HTMLSelectElement).value;
      this.pageChanged.emit(+page);
    });

    this.el.querySelectorAll('a')?.forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault();
        this.pushToBrowserhistory();
        const page = (event.target as HTMLAnchorElement);
        this.pageChanged.emit(+page.dataset.page);
      });
    });

    //Detect if the user navigates through the browser history to also emit a page change event
    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(window.location.search);
      const page = Number(params.get('page')) ?? 1;
      this.pageChanged.emit(page);
    });

  }

  //Make the product list page pagination also navigational in the browser history
  pushToBrowserhistory(){
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    const href = window.location.href;
    window.history.pushState({}, '', href);
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
